import { render, staticRenderFns } from "./FormulaList.vue?vue&type=template&id=6bf67208"
import script from "./FormulaList.vue?vue&type=script&lang=js"
export * from "./FormulaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports